export default __webpack_public_path__ + "static/media/C_05_05_bg.5c3b984c.mp4";